import styled from 'styled-components';

export const Container = styled.div`
  min-height: 100vh;
  width: 100%;
  background: var(--white-dark);
  display: flex;
  flex-direction: column;

  @media (max-width: 800px) {
    padding: 0;
  }
`;

export const Content = styled.div`
  height: 100%;
  width: 100%;
  padding: 40px 30%;

  @media (max-width: 800px) {
    padding: 10%;
  }
`;

export const DateInput = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 2fr;
  grid-template-rows: auto;
  margin-bottom: 20px;
  gap: 10px;
`;

export const ImagesWrapper = styled.div`
  position: relative;
`;

export const SecondaryButton = styled.button`
  width: 100%;
  height: 60px;
  color: var(--black-2);
  background: transparent;
  padding: 0;
  font-weight: 500;
  font-size: 16px;
  cursor: pointer;
  outline: none;

  display: flex;
  align-items: center;
  justify-content: space-between;
`;
